<template>
  <div class="dea-tooltip">
    <div
      class="dea-tooltip__inner"
      :class="[
        { 'dea-tooltip__inner--negative': negative },
        `dea-tooltip__inner--${side}`,
        `dea-tooltip__inner--${side}--${position}`,
      ]"
    >
      <div class="dea-tooltip__content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * I tooltip forniscono informazioni aggiuntive al passaggio del mouse o al focus. Spesso contengono un testo di aiuto contestuale a un elemento.<br>È possibile gestirne: le tre posizioni della freccia su ogni singolo lato e il colore dell'elemento (in positivo e in negativo).
 */
export default {
  name: "Tooltip",

  props: {
    negative: {
      type: Boolean,
      default: false,
    },
    side: {
      type: String,
      default: "",
    },
    position: {
      type: String,
      default: "",
    },
  },
};
</script>
